import r2wc from '@r2wc/react-to-web-component';
import { WebComponentWrapper } from './WebComponentWrapper.tsx';
import { NationalViewPage } from '../components/Pages/NationalViewPage.tsx';
import type {LandingPageLink} from "./LandingPageWebComponent";

type Props = {
	year?: number,
	data_appendix?: string,
	highlights?: string,
	intro_text?: string,
	last_updated?: string,
	methodology?: string,
	section_1_chart_heading?: string,
	section_2_chart_heading?: string,
	section_3_chart_heading?: string,
	menu_links?: LandingPageLink[],
	national_view_filter?: string,
	ussenate_data?: string,
	ushouse_data?: string,
};

const WrappedPage = (
	{
		year,
		menu_links,
		national_view_filter,
		data_appendix,
		highlights,
		intro_text,
		last_updated,
		methodology,
		section_1_chart_heading,
		section_2_chart_heading,
		section_3_chart_heading,
		ussenate_data,
		ushouse_data
	}: Props) => {
	// Build section headings object
	const sectionHeadings: Record<string, string> = {};
	if (section_1_chart_heading) sectionHeadings.section_1 = section_1_chart_heading;
	if (section_2_chart_heading) sectionHeadings.section_2 = section_2_chart_heading;
	if (section_3_chart_heading) sectionHeadings.section_3 = section_3_chart_heading;

	return (
		<WebComponentWrapper
			year={year}
			dataFormProvider
			menuLinks={menu_links}
			pageContent={{
				introText: intro_text,
				highlights,
				methodology,
				dataAppendix: data_appendix,
				lastUpdated: last_updated,
				sectionHeadings
			}}
			customFilterUrl={national_view_filter}
			ussenateData={ussenate_data}
			ushouseData={ushouse_data}
		>
			<NationalViewPage />
		</WebComponentWrapper>
	);
};

export const WebNationalPagePage = r2wc(WrappedPage, {
	props: {
		year: 'number',
		menu_links: 'json',
		national_view_filter: 'string',
		data_appendix: 'string',
		highlights: 'string',
		intro_text: 'string',
		last_updated: 'string',
		methodology: 'string',
		section_1_chart_heading: 'string',
		section_2_chart_heading: 'string',
		section_3_chart_heading: 'string',
		ussenate_data: 'string',
		ushouse_data: 'string'
	}
});
